import React from 'react';

import { AppDispatch } from 'types/state';

export const AppDispatchContext = React.createContext<null | AppDispatch>(null);
